import { isUserOnline, presenceStampMs } from "../../utils";

/**
 * Prefer a live presence overlay over the last REST stamp on a member.
 *
 * @param {object|null|undefined} member
 * @param {Record<string, string>} [presenceByUserId]
 * @returns {string}
 */
export function memberLastOnline(member, presenceByUserId = {}) {
  if (!member) return "";
  const overlay = presenceByUserId[String(Number(member.user_id))] || "";
  const rest = member.last_online || "";
  return presenceStampMs(overlay) >= presenceStampMs(rest)
    ? overlay || rest
    : rest;
}

/**
 * Count currently active human members, including the viewer when they belong.
 *
 * @param {object|null|undefined} chatInfo
 * @param {Date} [now]
 * @param {Record<string, string>} [presenceByUserId]
 * @returns {number}
 */
export function recomputeActiveNowCount(
  chatInfo,
  now = new Date(),
  presenceByUserId = {}
) {
  const others = (chatInfo?.other_members || []).filter(
    (member) =>
      !member.is_org &&
      isUserOnline(memberLastOnline(member, presenceByUserId), now)
  ).length;
  const viewerIsMember = Number(chatInfo?.member_id) > 0;
  return others + (viewerIsMember ? 1 : 0);
}

/**
 * Apply a presence stamp to chat info and refresh active_now_count.
 *
 * @param {object|null|undefined} chatInfo
 * @param {number|string} userId
 * @param {string} lastOnline
 * @param {Date} [now]
 * @param {Record<string, string>} [presenceByUserId]
 * @returns {object|null|undefined}
 */
export function applyPresenceToChat(
  chatInfo,
  userId,
  lastOnline,
  now = new Date(),
  presenceByUserId = {}
) {
  if (!chatInfo) return chatInfo;
  const uid = Number(userId);
  const others = (chatInfo.other_members || []).map((member) =>
    Number(member.user_id) === uid ? { ...member, last_online: lastOnline } : member
  );
  const next = { ...chatInfo, other_members: others };
  const overlay = { ...presenceByUserId, [String(uid)]: lastOnline };
  next.active_now_count = recomputeActiveNowCount(next, now, overlay);
  return next;
}
